/**
 * Converts a raw dish API object into the shape expected by DishForm.
 * Shared between DishView (single edit) and PostAIWizard (bulk review).
 */
export const convertDishToFormData = (dish, t) => ({
  ...dish,
  finalPrice: dish.discount
    ? dish.price - (dish.price * dish.discount) / 100
    : dish.price,
  dishtype: {
    label: dish.dishtype ? t(`utils.dishTypes.${dish.dishtype.label}`) : null,
    value: dish.dishtype || null,
  },
  dishcategory: {
    label: dish.dishcategory ? dish.dishcategory.label : null,
    value: dish.dishcategory || null,
  },
  allergies: dish.allergies?.map((a) =>
    !a.value ? { label: t(`utils.allergies.${a.label}`), value: a } : a,
  ),
  variantGroups: dish.variantGroups?.map((g) =>
    !g.value ? { label: g.label, value: g } : g,
  ),
});

/**
 * Derives a preview image URL from dish data.
 * Returns a blob URL for File objects, the existing path for strings, or null.
 */
export const getDishPreviewImg = (dish, fallbackImgPath = null) => {
  if (dish?.imagePath instanceof File) {
    return URL.createObjectURL(dish.imagePath);
  }
  if (dish?.imagePath) {
    return fallbackImgPath || dish.fullImagePath || null;
  }
  return null;
};
